//  Client\client-vite\src\pages\Dealers\DealersPage.tsx

const DealersPage = () => {
  return (
    <div>DealersPage</div>
  )
}

export default DealersPage